import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PP_LANGUAGE, PP_REGION } from "../constants/storage";
import { Cookie } from "../services/storage";
import { ApplicationState } from "../store";
import { actionSetPrivacyLanguageRegion } from "../store/actions/privacy-actions";
import { PrivacyState } from "../store/reducers/privacy-reducer";
import { UserState } from "../store/reducers/user-reducer";
import { UtilsLocale } from "../utils/UtilsLocale";
import { useCookie } from "./cookie-hooks";

export const usePrivacyPolicy = () => {
  const dispatch = useDispatch();
  const { isFCAllowed } = useCookie();

  const userState = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );
  const privacyState = useSelector<ApplicationState, PrivacyState>(
    (state) => state.privacy
  );
  const { userCountryCode } = userState;

  useEffect(
    () => {
      if (userCountryCode !== "" && !privacyState.language) {
        const ppLangData = UtilsLocale.getPPLanguageForCountry(userCountryCode);
        if (ppLangData) {
          updatePrivacyPolicyLanguage(
            `${ppLangData.languageCode}-${userCountryCode}`,
            ppLangData.region,
            true
          );
        }
      }
    },
    // eslint-disable-next-line
    [userCountryCode]
  );

  const updatePrivacyPolicyLanguage = (
    language: string,
    region: string,
    saveCookie = false
  ) => {
    if (saveCookie) {
      if (isFCAllowed) {
        Cookie.set(PP_REGION, region, { expires: 365 });
        Cookie.set(PP_LANGUAGE, language, { expires: 365 });
      }
    }

    dispatch(
      actionSetPrivacyLanguageRegion({
        language,
        region,
      })
    );
  };

  return {
    updatePrivacyPolicyLanguage,
  };
};
